var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.921 21.506-1.509 1.698h5.538v.252c0 .566.403 2.09 2.014 3.65C17.975 29.056 20.87 30 23.89 30c2.416 0 4.782-.378 5.663-.566v-9.187h-5.286c0 .105.101.416.504.818.403.403.462.881.441 1.07v4.97c-.46.043-1.71.101-3.02 0-1.635-.125-3.27-3.838-3.46-7.55-.188-3.712 3.02-5.852 5.537-5.789 2.014.05 3.482 1.238 3.965 1.825v-3.774c-.44-.19-1.813-.58-3.776-.63-2.454-.062-4.656.19-6.103.881-1.158.554-2.412 1.825-2.895 2.391v-1.07c1.657-3.208 5.047-9.777 5.349-10.381.302-.604.587-.881.692-.944H15.96c.251.23.805.742 1.007.944.2.201.082.587-.001.755l-2.77 5.789h-.377L10.361 2H3l.692.44 6.23 10.76v8.306z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYgg);
export default __webpack_public_path__ + "static/media/YGG.9aaf0f65796de5d6b267f32fe143addd.svg";
export { ForwardRef as ReactComponent };